import { render, staticRenderFns } from "./AnimationPanel.vue?vue&type=template&id=3a4f0f50&scoped=true"
import script from "./AnimationPanel.vue?vue&type=script&lang=js"
export * from "./AnimationPanel.vue?vue&type=script&lang=js"
import style0 from "./AnimationPanel.vue?vue&type=style&index=0&id=3a4f0f50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4f0f50",
  null
  
)

export default component.exports